/**
 * Analytics `source` for every nurses-matrix event. Kept VERBATIM from the legacy NursesMatrixTable so
 * event streams stay continuous across the migration — do not rename.
 */
export const NURSES_MATRIX_ANALYTICS_SOURCE = "nurses_matrix_table";

/**
 * Controlled picking on `NursesMatrixGrid`: `"single"` renders a radio column (one nurse, Enter commits),
 * `"multiple"` a checkbox column (any number, Enter/Space toggle). Absent = the legacy CheckCircle picker.
 */
export type NursesMatrixSelectionMode = "single" | "multiple";

/** Field of the leading radio/checkbox column the selection modes add. */
export const SELECT_COLUMN_FIELD = "__select";

/** Grid row identity — `rowKey` when a nurse is listed more than once, the nurse id otherwise. */
export type NursesMatrixRowId = string | number;
